import { getOrderApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { AssignExecutorToOrderRequest } from '@/core/generated/api';

/** Назначает исполнителя на заказ */
export const assignExecutorService = {
    /** Отправляет назначение и возвращает ссылку на договор */
    async assign(request: AssignExecutorToOrderRequest): Promise<string | null> {
        try {
            const response = await getOrderApi()
                .assignExecutorToOrder({
                    assignExecutorToOrderRequest: request,
                });

            return response.data || null;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
